import { render, staticRenderFns } from "./indexWelcome.vue?vue&type=template&id=585cadd8&scoped=true"
import script from "./indexWelcome.vue?vue&type=script&lang=js"
export * from "./indexWelcome.vue?vue&type=script&lang=js"
import style0 from "./indexWelcome.vue?vue&type=style&index=0&id=585cadd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585cadd8",
  null
  
)

export default component.exports